// extend yup
import "./yup-extensions";

// other stuff
import Router from "routes/router";
import { ToastContainer } from "react-toastify";
import { GlobalStyleSheet } from "theme/global";

// add dayjs duration
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

// plugin styles
import "react-toastify/dist/ReactToastify.css";
import ThemeProvider from "theme/providers";

function App() {
  return (
    <ThemeProvider>
      <GlobalStyleSheet />
      <Router />
      <ToastContainer />
    </ThemeProvider>
  );
}

export default App;
